module.exports = (__webpack_require__(78241))(1506);